var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{ tagSelected: _vm.isSelected},on:{"click":_vm.onTagClicked}},[_vm._v(_vm._s(_vm.tag.name))])}
var staticRenderFns = []

export { render, staticRenderFns }